import { initServices } from './serviceConfig'

let _svc
let _that

export default {
  Init: async (that) => {
    _that = that

    _svc = await initServices()

    _svc.interceptors.response.use(
      response => response,
      error => {
        _that.ErrorMixin_HandleError(error)
      }
    )
  },
  Download: (id) => {
    try {
      return _svc.get(`Blob/Download/${id}`, {
        responseType: 'blob'
      })
    } catch {
      return null
    }
  },
  GetBySearchCriteria: (searchCriteria) => {
    try {
      return _svc.post('Blob/GetBySearchCriteria', searchCriteria)
    } catch {
      return null
    }
  },
  Save: (blobs) => {
    try {
      return _svc.post('Blob/Save', blobs)
    } catch {
      return null
    }
  }
}
